import GallerySlider, {SELECTORS as GALLERYSLIDER_SELECTORS} from '../../../Components/Gallery/GallerySlider';

import '../../../Components/Gallery/_gallery-slider.scss';

$(GALLERYSLIDER_SELECTORS.root).each((i, galleryslider) => {
    new GallerySlider(galleryslider);
});